export enum AccionLogin {
    ConfiguracionInicial = 0,
    AguardandoValidacion = 1,
    AccesoHabilitado = 2,
    AccesoProhibido = 3
}